import { render, staticRenderFns } from "./EocBadgeCategoryCrud.vue?vue&type=template&id=ad5cbe0a&"
import script from "./EocBadgeCategoryCrud.vue?vue&type=script&lang=js&"
export * from "./EocBadgeCategoryCrud.vue?vue&type=script&lang=js&"
import style0 from "./EocBadgeCategoryCrud.vue?vue&type=style&index=0&id=ad5cbe0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports